<template>
  <div class="cards">
    <div class="cards__item" v-for="item in dateList" :key="item.id">
      <clouded-glass class="h-100">
        <div slot="content" class="h-100" style="width: 450px;">
          <div class="text-center font-weight-bold" style="padding-top: 40px;margin-left: -30px">{{ item.cnName }}</div>
          <div style="display: flex;height: calc(100% - 120px)">
            <div style="flex-basis: 43%">
              <temperature-chart :data="item.tempAvg" style="height: 100%"
                                 :scope="alarmScope[item.id] ? alarmScope[item.id].tm : [0,0]"></temperature-chart>
            </div>
            <div style="flex-basis: 50%;margin-left: 25px">
              <liquid-fill style="height: 100%" :data="item.humiAvg"
                           :scope="alarmScope[item.id] ? alarmScope[item.id].hu : [30,0]"></liquid-fill>
            </div>
            <div style="margin-left: -30px; width: 60%;height: 60%;margin-top: 13%">
              <pue-gauge-chart :data="item.pueValue" ref="lineChart" style="height: 100%"
                               v-if="item.pueValue"></pue-gauge-chart>
              <pue-gauge-chart :data="0" ref="lineChart" style="height: 100%"
                               v-else></pue-gauge-chart>
            </div>
          </div>
          <div style="display: flex;height: 60px;margin-top: -30px">
            <div style="flex-basis: 33%">
              <div class="text-center font-weight-bold" style="font-size: 1.15rem">{{ item.tempAvg }}℃</div>
              <div class="text-blueGrey text-center" style="font-size: 0.9rem">平均温度</div>
            </div>
            <div style="padding-right: 15px;flex-basis: 30%">
              <div class="text-center font-weight-bold" style="font-size: 1.15rem">{{ item.humiAvg }}%</div>
              <div class="text-blueGrey text-center" style="font-size: 0.9rem">平均湿度</div>
            </div>
            <div style="flex-basis: 30%;padding-left: 5%">
              <div class="text-center font-weight-bold" style="font-size: 1.15rem" v-if="item.pueValue">{{ item.pueValue }}</div>
              <div class="text-center font-weight-bold" style="font-size: 1.15rem" v-else>-</div>
              <div class="text-blueGrey text-center" style="font-size: 0.9rem">平均PUE</div>
            </div>
          </div>
        </div>
      </clouded-glass>
    </div>
  </div>
</template>

<script>
import {
  getAllSpaceTemperatureAndHumidity,
  getAllSpaceTemperatureAndHumidityAlarm
} from "@/network/measuring-point-history";
import {getPueByTime} from "@/network/ems-record.js"
import CloudedGlass from "@/components/style/CloudedGlass";
import temperatureChart from "@/components/echarts/temperatureChart";
import LiquidFill from "@/components/echarts/LiquidFill";
import pueGaugeChart from "@/components/echarts/pueGaugeChart";

export default {
  name: "AllSpaceTemperatureHumidity.vue",
  components: {CloudedGlass, temperatureChart, LiquidFill, pueGaugeChart},
  data() {
    return {
      deviceList: [],
      timer: null,
      alarmScope: {},
      gaugeData: 1.5,
      pueDateList: [],
      dateList:[],
    }
  },
  mounted() {
    this.getAlarmValue()
    this.timer = setInterval(() => this.getData(), 2000)
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    getData() {
      getAllSpaceTemperatureAndHumidity().then(res => {
        if (res.code === 0) {
          this.deviceList = res.data;
          this.getPueData();
        }
      })
    },
    getPueData() {
      getPueByTime().then(res => {
        if (res.code === 0) {
          this.pueDateList = res.data
        }
      })
      this.dateList=[];
        this.deviceList.forEach(item2 => {
          this.pueDateList.forEach( item1 =>{
          if (item2.cnName === item1.spaceName){
            item2.pueValue=item1.pueValue;
          }
        })
          this.dateList.push(item2);
      })
    },
    getAlarmValue() {
      getAllSpaceTemperatureAndHumidityAlarm().then(res => {
        if (res.code === 0) {
          this.alarmScope = res.data
          this.getData();
        }
      })
    },
  },
}
</script>

<style scoped>
.cards {
  display: flex;
  /* Put a card in the next row when previous cards take all width */
  flex-wrap: wrap;
  padding: 20px;
  height: 95vh;
  overflow: auto;
}

.cards__item {
  /* There will be 4 cards per row */
  flex-basis: 268px;
  height: 378px;
  margin: 8px;
}

.flex-50 {
  flex-basis: 50%;
}

.temp {
}

.humi {
}
</style>
